import { GetterTree } from 'vuex'
import { MealState, IMealState } from './state';

export const mealGetters: GetterTree<MealState, IMealState> = {
  lastSyncUtc: (state: MealState) => state.lastSyncUtc,
  mealCountDtos: (state: MealState) => state.mealCountDtos,
  mealCountStatuses: (state: MealState) => state.mealCountStatuses,
  syncUpCounts: (state: MealState) => state.syncUpCounts,
  tempDto: (state: MealState) => state.tempDto,
  mergeServingLines: (state: MealState) => state.mergeServingLines
};
